(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-spatula-bundle"] && !Shopify.designMode) return;
  try {
    
  class BlackFridayBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.spatulaQuantities = new Map();
      this.addonQuantities = new Map();
      this.maxTrios = Number(this.dataset.maxTrios) || 3;
      this.loading = false;
      this.spatulaCards = Array.from(this.querySelectorAll('[data-spatula-card]'));
      this.addonCards = Array.from(this.querySelectorAll('[data-addon-card]'));
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.countElement = this.querySelector('[data-spatula-count]');
      this.capacityElement = this.querySelector('[data-spatula-capacity]');
      this.addonCountElement = this.querySelector('[data-addon-count]');
      this.addonCapacityElement = this.querySelector('[data-addon-capacity]');
      this.progressElement = this.querySelector('[data-progress]');
      this.slotsElement = this.querySelector('[data-slots]');
      this.regularValueElement = this.querySelector('[data-regular-value]');
      this.savingsElement = this.querySelector('[data-savings]');
      this.bundlePriceElement = this.querySelector('[data-bundle-price]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.statusElement = this.querySelector('[data-status]');
      this.successElement = this.querySelector('[data-bundle-success]');
      this.currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      this.addEventListener('click', (event) => this.handleClick(event));
      this.update();
    }

    get spatulaCount() {
      return Array.from(this.spatulaQuantities.values()).reduce((total, quantity) => total + quantity, 0);
    }

    get addonCount() {
      return Array.from(this.addonQuantities.values()).reduce((total, quantity) => total + quantity, 0);
    }

    get completedTrios() {
      return Math.floor(this.spatulaCount / 3);
    }

    handleClick(event) {
      const spatulaIncrease = event.target.closest('[data-spatula-increase]');
      const spatulaDecrease = event.target.closest('[data-spatula-decrease]');
      const addonIncrease = event.target.closest('[data-addon-increase]');
      const addonDecrease = event.target.closest('[data-addon-decrease]');
      const filter = event.target.closest('[data-filter]');
      if (spatulaIncrease) this.changeSpatula(spatulaIncrease.closest('[data-spatula-card]'), 1);
      if (spatulaDecrease) this.changeSpatula(spatulaDecrease.closest('[data-spatula-card]'), -1);
      if (addonIncrease) this.changeAddon(addonIncrease.closest('[data-addon-card]'), 1);
      if (addonDecrease) this.changeAddon(addonDecrease.closest('[data-addon-card]'), -1);
      if (filter) this.setFilter(filter);
      if (event.target.closest('[data-add-bundle]')) this.addBundle();
      if (event.target.closest('[data-build-another]')) this.buildAnother();
    }

    setFilter(filter) {
      const value = filter.dataset.filter;
      this.filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
      this.spatulaCards.forEach((card) => {
        card.hidden = value !== 'all' && card.dataset.kind !== value;
      });
    }

    changeSpatula(card, change) {
      if (!card) return;
      const variantId = card.dataset.variantId;
      const current = this.spatulaQuantities.get(variantId) || 0;
      const next = current + change;
      if (next < 0) return;
      if (change > 0 && this.spatulaCount >= this.maxTrios * 3) {
        this.setStatus(this.dataset.fullMessage);
        return;
      }
      const addonsAdjusted = change < 0
        ? this.trimAddonsToCapacity(Math.floor((this.spatulaCount - 1) / 3))
        : false;
      if (next === 0) this.spatulaQuantities.delete(variantId);
      else this.spatulaQuantities.set(variantId, next);
      this.setStatus(addonsAdjusted ? this.dataset.removeAddonMessage : '');
      this.update();
    }

    trimAddonsToCapacity(capacity) {
      let excess = this.addonCount - capacity;
      if (excess <= 0) return false;

      const entries = Array.from(this.addonQuantities.entries()).reverse();
      entries.forEach(([variantId, quantity]) => {
        if (excess <= 0) return;
        const removeQuantity = Math.min(quantity, excess);
        const nextQuantity = quantity - removeQuantity;
        if (nextQuantity === 0) this.addonQuantities.delete(variantId);
        else this.addonQuantities.set(variantId, nextQuantity);
        excess -= removeQuantity;
      });

      return true;
    }

    changeAddon(card, change) {
      if (!card) return;
      const variantId = card.dataset.variantId;
      const current = this.addonQuantities.get(variantId) || 0;
      const next = current + change;
      if (next < 0) return;
      if (change > 0 && this.addonCount >= this.completedTrios) {
        this.setStatus(this.dataset.addonLimitMessage);
        return;
      }
      if (next === 0) this.addonQuantities.delete(variantId);
      else this.addonQuantities.set(variantId, next);
      this.setStatus('');
      this.update();
    }

    selectedItems(cards, quantities) {
      const selected = [];
      cards.forEach((card) => {
        const quantity = quantities.get(card.dataset.variantId) || 0;
        if (!quantity) return;
        selected.push({
          id: Number(card.dataset.variantId),
          quantity,
          price: Number(card.dataset.price),
          title: card.dataset.title,
          image: card.dataset.image
        });
      });
      return selected;
    }

    update() {
      const spatulas = this.selectedItems(this.spatulaCards, this.spatulaQuantities);
      const addons = this.selectedItems(this.addonCards, this.addonQuantities);
      const maxSpatulas = this.maxTrios * 3;
      const completedTrios = this.completedTrios;
      this.countElement.textContent = String(this.spatulaCount);
      this.capacityElement.textContent = String(maxSpatulas);
      this.addonCountElement.textContent = String(this.addonCount);
      this.addonCapacityElement.textContent = String(completedTrios);

      this.spatulaCards.forEach((card) => this.updateCard(card, this.spatulaQuantities, this.spatulaCount >= maxSpatulas));
      this.addonCards.forEach((card) => this.updateCard(card, this.addonQuantities, this.addonCount >= completedTrios));
      this.renderSlots(spatulas, maxSpatulas);

      const unitPrices = [];
      spatulas.forEach((item) => {
        for (let index = 0; index < item.quantity; index += 1) unitPrices.push(item.price);
      });
      unitPrices.sort((a, b) => a - b);
      const spatulaSavings = unitPrices.slice(0, completedTrios).reduce((total, price) => total + price, 0);
      const addonValue = addons.reduce((total, item) => total + item.price * item.quantity, 0);
      const addonSavings = addons.reduce((total, item) => total + Math.floor(item.price * 0.5) * item.quantity, 0);
      const spatulaValue = unitPrices.reduce((total, price) => total + price, 0);
      const regularValue = spatulaValue + addonValue;
      const savings = spatulaSavings + addonSavings;
      const estimatedPrice = regularValue - savings;
      const ready = this.spatulaCount >= 3 && this.spatulaCount % 3 === 0;

      this.regularValueElement.textContent = this.spatulaCount ? this.formatMoney(regularValue) : '—';
      this.savingsElement.textContent = ready ? this.formatMoney(savings) : '—';
      this.bundlePriceElement.textContent = ready ? this.formatMoney(estimatedPrice) : '—';
      this.progressElement.textContent = this.progressMessage(completedTrios);
      this.addButton.disabled = !ready || this.loading;
      if (this.loading) this.addButton.textContent = this.dataset.loadingText || 'Adding your Black Friday bundle…';
      else if (ready) this.addButton.textContent = `Add ${completedTrios} bundle${completedTrios === 1 ? '' : 's'} — ${this.formatMoney(estimatedPrice)}`;
      else {
        const nextTarget = Math.min((completedTrios + 1) * 3, maxSpatulas);
        const remaining = Math.max(nextTarget - this.spatulaCount, 0);
        this.addButton.textContent = `Choose ${remaining} more spatula${remaining === 1 ? '' : 's'}`;
      }
    }

    updateCard(card, quantities, limitReached) {
      const quantity = quantities.get(card.dataset.variantId) || 0;
      card.dataset.selected = String(quantity > 0);
      const quantityElement = card.querySelector('[data-quantity]');
      const increase = card.querySelector('[data-spatula-increase], [data-addon-increase]');
      const decrease = card.querySelector('[data-spatula-decrease], [data-addon-decrease]');
      if (quantityElement) quantityElement.textContent = String(quantity);
      if (increase) increase.disabled = limitReached;
      if (decrease) decrease.disabled = quantity === 0;
    }

    renderSlots(spatulas, capacity) {
      const selected = [];
      spatulas.forEach((item) => {
        for (let index = 0; index < item.quantity; index += 1) selected.push(item);
      });
      const slots = [];
      for (let index = 0; index < capacity; index += 1) {
        const slot = document.createElement('div');
        const item = selected[index];
        if (item) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          slot.appendChild(image);
        } else {
          const label = document.createElement('span');
          label.textContent = String(index + 1);
          slot.appendChild(label);
        }
        slots.push(slot);
      }
      this.slotsElement.replaceChildren(...slots);
    }

    progressMessage(completedTrios) {
      if (!this.spatulaCount) return this.dataset.progressEmptyText;
      if (this.spatulaCount % 3 === 0) {
        return `${completedTrios} free spatula${completedTrios === 1 ? '' : 's'} unlocked. You may add ${completedTrios} half-price extra${completedTrios === 1 ? '' : 's'}.`;
      }
      const remaining = 3 - (this.spatulaCount % 3);
      return `Choose ${remaining} more spatula${remaining === 1 ? '' : 's'} to unlock another free Pat.`;
    }

    formatMoney(cents) {
      return this.currency.format(cents / 100);
    }

    setStatus(message) {
      if (this.statusElement) this.statusElement.textContent = message || '';
    }

    buildAnother() {
      if (this.successElement) this.successElement.hidden = true;
      this.querySelector('[data-spatula-card]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    async addBundle() {
      if (this.loading || this.spatulaCount < 3 || this.spatulaCount % 3 !== 0) return;
      this.loading = true;
      if (this.successElement) this.successElement.hidden = true;
      this.update();
      try {
        const root = this.dataset.rootUrl || '/';
        const bundleId = globalThis.crypto?.randomUUID?.() || `pat-black-friday-${Date.now()}`;
        const spatulas = this.selectedItems(this.spatulaCards, this.spatulaQuantities).map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _pat_bundle: 'black-friday',
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'spatula'
          }
        }));
        const addons = this.selectedItems(this.addonCards, this.addonQuantities).map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _pat_bundle: 'black-friday',
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'addon'
          }
        }));
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [...spatulas, ...addons] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.errorMessage);
        this.loading = false;
        this.spatulaQuantities.clear();
        this.addonQuantities.clear();
        this.setStatus('');
        this.update();
        if (this.successElement) {
          this.successElement.hidden = false;
          this.successElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } catch (error) {
        this.loading = false;
        this.setStatus(error.message || this.dataset.errorMessage);
        this.update();
      }
    }
  }

  if (!customElements.get('black-friday-bundle')) {
    customElements.define('black-friday-bundle', BlackFridayBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pat-four-pack-add]');
    if (!button || button.closest('#pat-drawer-offer')) return;
    const offer = button.closest('[data-pat-four-pack-extra]');
    if (!offer || offer.dataset.busy === 'true') return;
    const controls = offer.querySelectorAll('button');
    const status = offer.querySelector('[data-pat-four-pack-status]');
    const root = window.Shopify.routes.root;
    const request = async (path, body) => {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };
    offer.dataset.busy = 'true';
    controls.forEach(control => { control.disabled = true; });
    status.textContent = offer.dataset.busyLabel || '';
    try {
      const cartForm = button.closest('form');
      const quantities = [...cartForm.querySelectorAll('[name="updates[]"]')].map(input => Number(input.value));
      if (quantities.some(value => !Number.isInteger(value) || value < 0)) throw new Error('Invalid quantity');
      let cart = await request('cart/update.js', { updates: quantities });
      const hasFourPack = cart.items.some(item => item.handle === 'sudsy-pat-4-pack');
      const hasFourPackExtra = cart.items.some(item => item.properties?._pat_cart_addon === 'four-pack-extra');
      if (cart.currency !== 'USD' || cart.total_price >= 5000 || !hasFourPack || hasFourPackExtra) {
        window.location.assign(root + 'cart');
        return;
      }
      await request('cart/add.js', {
        items: [{
          id: Number(button.dataset.patFourPackAdd),
          quantity: 1,
          properties: { _pat_cart_addon: 'four-pack-extra' }
        }]
      });
      cart = await request('cart.js');
      const selected = cart.items.find(item =>
        item.properties?._pat_cart_addon === 'four-pack-extra' &&
        Number(item.variant_id) === Number(button.dataset.patFourPackAdd)
      );
      if (!selected) throw new Error('Add-on unavailable');
      window.location.assign(root + 'cart');
    } catch (error) {
      status.textContent = offer.dataset.error || '';
      offer.dataset.busy = 'false';
      controls.forEach(control => { control.disabled = false; });
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pat-wooden-add]');
    if (!button || button.closest('#pat-drawer-offer')) return;
    const offer = button.closest('[data-pat-wooden-offer]');
    if (offer.dataset.busy === 'true') return;
    const controls = offer.querySelectorAll('button');
    const status = offer.querySelector('[data-pat-wooden-status]');
    const root = window.Shopify.routes.root;
    const request = async (path, body) => {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };
    offer.dataset.busy = 'true';
    controls.forEach(control => { control.disabled = true; });
    status.textContent = offer.dataset.busyLabel || '';
    let added = false;
    try {
      const cartForm = button.closest('form');
      const quantities = [...cartForm.querySelectorAll('[name="updates[]"]')].map(input => Number(input.value));
      if (quantities.some(value => !Number.isInteger(value) || value < 0)) throw new Error('Invalid quantity');
      let cart = await request('cart/update.js', { updates: quantities });
      const bundleDiscounts = ['Silly Pat trio — 20% off', 'Wooden Pat trio — 20% off', 'Free Sudsy Pat sponge'];
      const discountsAllowed = !(cart.cart_level_discount_applications || []).length && cart.items.every(item =>
        (item.line_level_discount_allocations || []).every(allocation => bundleDiscounts.includes(allocation.discount_application.title))
      );
      const qualifyingTotal = cart.total_price;
      if (cart.currency !== 'USD' || cart.total_price < 4000 || cart.total_price >= 5000 || !discountsAllowed || cart.items.some(item => item.properties?._pat_cart_addon === 'wooden-999')) {
        window.location.assign(root + 'cart');
        return;
      }
      status.textContent = offer.dataset.busyLabel;
      for (const item of cart.items) {
        await request('cart/change.js', { id: item.key, quantity: item.quantity, properties: { ...item.properties, _pat_cart_addon: 'regular' } });
      }
      await request('cart/add.js', { items: [{ id: Number(button.dataset.patWoodenAdd), quantity: 1, properties: { _pat_cart_addon: 'wooden-999' } }] });
      added = true;
      cart = await request('cart.js');
      const selected = cart.items.find(item => item.properties?._pat_cart_addon === 'wooden-999');
      if (!selected || selected.quantity !== 1 || selected.final_line_price !== 999 || cart.total_price !== qualifyingTotal + 999) {
        if (selected) await request('cart/change.js', { id: selected.key, quantity: 0 });
        added = false;
        throw new Error('Offer price unavailable');
      }
      window.location.assign(root + 'cart');
    } catch (error) {
      if (added) {
        window.location.assign(root + 'cart');
        return;
      }
      status.textContent = offer.dataset.error;
      offer.dataset.busy = 'false';
      controls.forEach(control => { control.disabled = false; });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pat-black-friday-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pat-black-friday-popup]').forEach((popup) => {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const dialog = popup.querySelector('dialog');
    const storageKey = `pat-black-friday-popup-${popup.dataset.sectionId}`;
    const designMode = popup.dataset.designMode === 'true';
    const now = new Date();
    const startsAt = new Date(popup.dataset.startsAt);
    const endsAt = new Date(popup.dataset.endsAt);
    const scheduled = now >= startsAt && now < endsAt;

    const rememberDismissal = () => {
      if (designMode) return;
      try {
        window.sessionStorage.setItem(storageKey, 'dismissed');
      } catch {}
    };

    const close = () => {
      rememberDismissal();
      if (dialog.open) dialog.close();
    };

    const open = () => {
      if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
    };

    let dismissed = false;
    try {
      dismissed = window.sessionStorage.getItem(storageKey) === 'dismissed';
    } catch {}

    if ((designMode || scheduled) && !dismissed) {
      window.setTimeout(open, designMode ? 0 : Number(popup.dataset.delay) * 1000);
    }

    popup.querySelectorAll('[data-pat-black-friday-popup-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    popup.querySelectorAll('[data-pat-black-friday-popup-link]').forEach((link) => {
      link.addEventListener('click', rememberDismissal);
    });

    dialog.addEventListener('cancel', rememberDismissal);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === popup.dataset.sectionId) open();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pat-bundle-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pat-bundle-popup]').forEach((popup) => {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const dialog = popup.querySelector('dialog');
    const storageKey = `pat-bundle-popup-${popup.dataset.sectionId}`;
    const designMode = popup.dataset.designMode === 'true';
    const now = new Date();
    const pauseStart = new Date(popup.dataset.pauseStart);
    const pauseEnd = new Date(popup.dataset.pauseEnd);
    const blackFridayActive = now >= pauseStart && now < pauseEnd;

    const rememberDismissal = () => {
      if (designMode) return;
      try {
        window.sessionStorage.setItem(storageKey, 'dismissed');
      } catch {}
    };

    const close = () => {
      rememberDismissal();
      if (dialog.open) dialog.close();
    };

    const open = () => {
      if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
    };

    let dismissed = false;
    try {
      dismissed = window.sessionStorage.getItem(storageKey) === 'dismissed';
    } catch {}

    if (!blackFridayActive && (designMode || !dismissed)) {
      window.setTimeout(open, designMode ? 0 : Number(popup.dataset.delay) * 1000);
    }

    popup.querySelectorAll('[data-pat-popup-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    popup.querySelectorAll('[data-pat-popup-link]').forEach((link) => {
      link.addEventListener('click', rememberDismissal);
    });

    dialog.addEventListener('cancel', rememberDismissal);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail.sectionId === popup.dataset.sectionId) open();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silly-pat-trio-bundle"] && !Shopify.designMode) return;
  try {
    
  class SillyPatBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.quantities = new Map();
      this.sponge = null;
      this.loading = false;
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.spongeOptions = Array.from(this.querySelectorAll('[data-sponge-option]'));
      this.slots = Array.from(this.querySelectorAll('[data-slot]'));
      this.countElement = this.querySelector('[data-selected-count]');
      this.regularValueElement = this.querySelector('[data-regular-value]');
      this.savingsElement = this.querySelector('[data-savings]');
      this.bundlePriceElement = this.querySelector('[data-bundle-price]');
      this.addButton = this.querySelector('[data-add-bundle]');
      this.statusElement = this.querySelector('[data-status]');
      this.successElement = this.querySelector('[data-bundle-success]');
      this.currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

      this.addEventListener('click', (event) => this.handleClick(event));
      this.update();
    }

    get selectedCount() {
      return Array.from(this.quantities.values()).reduce((total, quantity) => total + quantity, 0);
    }

    handleClick(event) {
      const increase = event.target.closest('[data-increase]');
      const decrease = event.target.closest('[data-decrease]');
      const spongeOption = event.target.closest('[data-sponge-option]');
      const filter = event.target.closest('[data-filter]');

      if (increase) this.changeQuantity(increase.closest('[data-product-card]'), 1);
      if (decrease) this.changeQuantity(decrease.closest('[data-product-card]'), -1);
      if (spongeOption) this.selectSponge(spongeOption);
      if (filter) this.setFilter(filter);
      if (event.target.closest('[data-add-bundle]')) this.addBundle();
      if (event.target.closest('[data-build-another]')) this.buildAnother();
    }

    setFilter(filter) {
      const value = filter.dataset.filter;
      this.filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
      this.cards.forEach((card) => {
        card.hidden = value !== 'all' && card.dataset.kind !== value;
      });
    }

    changeQuantity(card, change) {
      if (!card) return;
      const variantId = card.dataset.variantId;
      const current = this.quantities.get(variantId) || 0;
      const next = current + change;

      if (next < 0) return;
      if (change > 0 && this.selectedCount >= 3) {
        this.setStatus('Your trio is full. Remove a spatula to choose another.');
        return;
      }

      if (next === 0) this.quantities.delete(variantId);
      else this.quantities.set(variantId, next);
      this.setStatus('');
      this.update();
    }

    selectSponge(option) {
      this.sponge = {
        id: option.dataset.variantId,
        price: Number(option.dataset.price),
        title: option.dataset.title
      };
      this.spongeOptions.forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
      this.setStatus('');
      this.update();
    }

    selectedItems() {
      const selected = [];
      this.cards.forEach((card) => {
        const quantity = this.quantities.get(card.dataset.variantId) || 0;
        if (!quantity) return;
        selected.push({
          id: Number(card.dataset.variantId),
          quantity,
          price: Number(card.dataset.price),
          kind: card.dataset.kind,
          discountRate: Number(card.dataset.discountRate),
          sku: card.dataset.sku,
          title: card.dataset.title,
          image: card.dataset.image
        });
      });
      return selected;
    }

    update() {
      const totalSelected = this.selectedCount;
      const selected = this.selectedItems();
      if (this.countElement) this.countElement.textContent = String(totalSelected);

      this.cards.forEach((card) => {
        const quantity = this.quantities.get(card.dataset.variantId) || 0;
        card.dataset.selected = String(quantity > 0);
        const quantityElement = card.querySelector('[data-quantity]');
        const increase = card.querySelector('[data-increase]');
        const decrease = card.querySelector('[data-decrease]');
        if (quantityElement) quantityElement.textContent = String(quantity);
        if (increase) increase.disabled = totalSelected >= 3;
        if (decrease) decrease.disabled = quantity === 0;
      });

      const selectedImages = [];
      selected.forEach((item) => {
        for (let index = 0; index < item.quantity; index += 1) selectedImages.push(item);
      });
      this.slots.forEach((slot, index) => {
        const item = selectedImages[index];
        slot.replaceChildren();
        if (item) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          slot.appendChild(image);
        } else {
          const label = document.createElement('span');
          label.textContent = String(index + 1);
          slot.appendChild(label);
        }
      });

      const fullProductValue = selected.reduce((total, item) => total + item.price * item.quantity, 0);
      const productSavings = selected.reduce((total, item) => {
        const discount = Math.floor(item.price * (item.discountRate / 100));
        return total + discount * item.quantity;
      }, 0);
      const regularValue = fullProductValue + (this.sponge ? this.sponge.price : 0);
      const bundlePrice = fullProductValue - productSavings;
      const savings = productSavings + (this.sponge ? this.sponge.price : 0);

      this.regularValueElement.textContent = totalSelected === 3 && this.sponge ? this.formatMoney(regularValue) : '—';
      this.savingsElement.textContent = totalSelected === 3 && this.sponge ? this.formatMoney(savings) : '—';
      this.bundlePriceElement.textContent = totalSelected === 3 ? this.formatMoney(bundlePrice) : '—';

      const ready = totalSelected === 3 && Boolean(this.sponge);
      this.addButton.disabled = !ready || this.loading;
      if (this.loading) this.addButton.textContent = 'Adding your happy bundle…';
      else if (ready) this.addButton.textContent = `Add bundle — ${this.formatMoney(bundlePrice)}`;
      else if (totalSelected < 3) this.addButton.textContent = `Choose ${3 - totalSelected} more spatula${3 - totalSelected === 1 ? '' : 's'}`;
      else this.addButton.textContent = 'Choose your free sponge';
    }

    formatMoney(cents) {
      return this.currency.format(cents / 100);
    }

    setStatus(message) {
      if (this.statusElement) this.statusElement.textContent = message;
    }

    buildAnother() {
      if (this.successElement) this.successElement.hidden = true;
      this.querySelector('[data-product-card]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    async addBundle() {
      if (this.loading || this.selectedCount !== 3 || !this.sponge) return;
      this.loading = true;
      if (this.successElement) this.successElement.hidden = true;
      this.update();
      try {
        const root = this.dataset.rootUrl || '/';
        const bundleId = globalThis.crypto?.randomUUID?.() || `pat-trio-${Date.now()}`;
        const items = this.selectedItems().map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _pat_bundle: 'trio',
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'pat',
            _pat_bundle_class: item.kind,
            _pat_bundle_item: item.kind === 'clementine' ? 'pat-clementine' : 'pat-standard'
          }
        }));
        items.push({
          id: Number(this.sponge.id),
          quantity: 1,
          properties: {
            _pat_bundle: 'trio',
            _pat_bundle_id: bundleId,
            _pat_bundle_role: 'sponge',
            _pat_bundle_class: 'sponge',
            _pat_bundle_item: 'sponge'
          }
        });

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add the bundle to your cart.');
        this.loading = false;
        this.quantities.clear();
        this.sponge = null;
        this.spongeOptions.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.setStatus('');
        this.update();
        if (this.successElement) {
          this.successElement.hidden = false;
          this.successElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } catch (error) {
        this.loading = false;
        this.setStatus(error.message || 'Something went wrong. Please try again.');
        this.update();
      }
    }
  }

  if (!customElements.get('silly-pat-bundle')) {
    customElements.define('silly-pat-bundle', SillyPatBundle);
  }

  } catch(e) { console.error(e); }
})();
})();
